import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../api/index";
const axios = require("axios");

const initialState = {
  loading: false,
  error: false,
  data: [],
};

const componentsSlice = createSlice({
  name: "components",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getComponentsByUserCode.pending, (state) => {
        state.loading = true;
      })
      .addCase(getComponentsByUserCode.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getComponentsByUserCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const getComponentsByUserCode = createAsyncThunk(
  "componentsSlice/getComponentsByUserCode",
  async (userCode) => {
    try {
      const { url, method, headers } = api.getComponentsByUserCode(userCode);
      const components = await axios({
        url,
        method,
        headers,
      });
      return components.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const { actions } = componentsSlice;
export default componentsSlice.reducer;
